import React, { useEffect, useState } from 'react';
import "./Work.css";
import db from '../firebase';
const Work = () => {
  
 const [projects,setprojects] = useState([])
   useEffect(()=>{
    db.collection('Projects4').orderBy("ord","asc").onSnapshot(function(querySnapshot){
        setprojects(
          querySnapshot.docs.map((doc)=>({
            id:doc.id,
            title:doc.data().title,
            about:doc.data().about,
            image: doc.data().image,
            tech:doc.data().tech,
            not: doc.data().not,
            lin:doc.data().lin,
            code:doc.data().code,
            note:doc.data().note
          }))
        );
      });
  },[]);
  
    
 
    return (
        <div className='Work' id='Projects'>
            <div className='Work_head'>
            <h1>PROJECTS</h1>
            <p>My Projetcs list</p>
            </div>
           <div className='work_list'>
                {
                 projects.map(pro=>(
                        <div className='work-card'>
                                <div className='work-left'>
                                <img className='work-img' src={pro.image} alt=''/>
                                </div>
                                <div className='work-right'>
                                <h4>{pro.title}</h4>
                                <div>
                                    <h5>About project:</h5>
                                    <p>{pro.about}
                                    </p>
                                </div>
                                <div>
                                    <h5>Technologies Used:</h5>
                                    <p>{pro.tech}</p>
                                </div>
                                         <div className='linksse'>
                                                 <a target={'_blank'} rel="noopener noreferrer" href={pro.code} title={'Github' } className='prolin'> <i class='bx bx-code-alt' ></i></a>
                                   <a href={pro.lin} title={'External link' } target={'_blank'} rel="noopener noreferrer"
                                   className='prolin' >  <i class='bx bx-link-external' ></i></a>
                                                
                                               
                                </div>
                                {pro.not&&<p className='note'>{pro.note}</p>}
                        </div>
                        </div>
                 ))
                 
                }

           </div>
           <div className='showmo'>
                <a target={'_blank'} rel="noopener noreferrer"href='https://github.com/rammathala?tab=repositories' className='showmore'
                >Explore all projects <i class='bx bx-chevrons-down downarrow'></i></a>
           </div>
        </div>
    );
};

export default Work;